module.exports = __webpack_public_path__ + "media/images/pt/performance_index_continuum-f0387f4e9c3da72a84d8c0d6ffd01cdb.png";